import { INR, USD } from "features/Listings/Listings.constants";

export const OFFER_TARGET_TYPE = {
  SPECIFIC_OFFERING: 1,
  SPECIFIC_PAYMENT_PAGE: 2,
  ALL_OFFERINGS: 3,
};

export const OFFER_TARGET_TYPE_OPTIONS = [
  {
    label: "Universal Offer - Applies to all Payment & Offering Pages",
    value: OFFER_TARGET_TYPE.ALL_OFFERINGS,
  },
  {
    label: "Specific Offering",
    value: OFFER_TARGET_TYPE.SPECIFIC_OFFERING,
  },
  {
    label: "Specific Payment Page",
    value: OFFER_TARGET_TYPE.SPECIFIC_PAYMENT_PAGE,
  },
];

export const OFFER_TYPE = {
  AMOUNT: 1,
  PERCENTAGE: 2,
};

export const OFFER_TYPE_OPTIONS = [
  { label: "Amount", value: OFFER_TYPE.AMOUNT },
  { label: "Percentage", value: OFFER_TYPE.PERCENTAGE },
];

export const TIMER_TYPE = {
  FIXED: 1,
  EVERGREEN: 2,
};

export const TIMER_TYPE_OPTIONS = [
  { label: "Fixed", value: TIMER_TYPE.FIXED },
  { label: "Evergreen", value: TIMER_TYPE.EVERGREEN },
];

export const DURATION_UNITS = [
  { label: "Minutes", value: "minutes" },
  { label: "Hours", value: "hours" },
  { label: "Days", value: "days" },
];

export const DURATION_UNIT_MULTIPLIERS = {
  seconds: 1 / 3600,
  minutes: 1 / 60,
  hours: 1,
  days: 24,
};

export const LTO_FORM_KEYS = {
  TARGET_TYPE: "target_type",
  COMBO_PAGES: "combo_pages",
  DYNAMIC_LINK_UUID: "dynamic_link_uuid",
  LISTINGS: "listings",
  DYNAMIC_LINK_UUIDS: "dynamic_link_uuids",
  OFFER_TYPE: "offer_type",
  TIMER_TYPE: "timer_type",
  EVERGREEN_DURATION_SECONDS: "evergreen_duration_seconds",
  EVERGREEN_DURATION_VALUE: "evergreen_duration_value",
  EVERGREEN_DURATION_UNIT: "evergreen_duration_unit",
  PERCENTAGE_VALUE: "percentage_value",
  INR_PRICE: "INRPrice",
  USD_CHECKBOX: "USD",
  USD_PRICE: "USDPrice",
};

export const LTO_EDIT_SESSION_KEY = "editData";

export const LTO_SUPPORTED_CURRENCIES = [INR, USD];

export const ONE_HOUR_IN_SECONDS = 3600;
